import React from 'react'
import SelectBox from '../../common/SelectBox'
import InputBox from '../../common/InputBox'
import Bonus from './Additional/Bonus'
import Overtime from './Additional/Overtime'
import {connect} from 'react-redux'
import {
  incomeEmployerTypeChanged,
} from '../../../../../actions'
import Checkbox from '../../../../commons/Checkbox'
import { getLoanApplicationUser, getSecondaryLoanApplicationUser, getMainIncome } from '../../../../../reducers'
import IncomeHeader from '../../IncomeHeader'
import Allowance from './Additional/Allowance'
import Commission from './Additional/Commission'

class PAYG extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      frequency: this.props.income.frequency || 'yearly',
      incomeType: 'Incomes::Payg',
      option: 'payg',
      additionalPaygIncomes: {
        bonus: {
          paygIncomeType: 'bonus',
          frequency: 'yearly',
          frequencyPreviousYear: 'yearly',
          active: false
        },
        overtime: {
          paygIncomeType: 'overtime',
          frequency: 'yearly',
          frequencyPreviousYear: 'yearly',
          active: false
        },
        commission: {
          paygIncomeType: 'commission',
          frequency: 'yearly',
          frequencyPreviousYear: 'yearly',
          active: false
        },
        allowance: {
          paygIncomeType: 'allowance',
          frequency: 'yearly',
          active: false
        }
      }
    }
    // preserve the initial state in a new object
    this.baseState = this.state
  }

  componentDidMount() {
    this.updateIncome({
      frequency: this.state.frequency,
      incomeType: this.state.incomeType,
      option: this.state.option,
    })

    const { income } = this.props
    const { additionalPaygIncomes } = income
    const { bonus, overtime, commission, allowance } = additionalPaygIncomes || this.state.additionalPaygIncomes

    this.setState({
      additionalPaygIncomes: {
        bonus: { ...this.state.additionalPaygIncomes.bonus, ...bonus, active: this.calcActive(bonus), },
        overtime: { ...this.state.additionalPaygIncomes.overtime, ...overtime, active: this.calcActive(overtime), },
        commission: { ...this.state.additionalPaygIncomes.commission,...commission, active: this.calcActive(commission), },
        allowance: { ...this.state.additionalPaygIncomes.allowance,...allowance, active: this.calcActive(allowance), }
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.income.id !== this.props.income.id) {
      window.scrollTo({top: 0})
      this.setState(this.baseState)
      this.updateIncome({
        frequency: this.state.frequency,
        incomeType: this.state.incomeType,
        option: this.state.option,
      })
      const { income } = this.props
      const { additionalPaygIncomes } = income
      const { bonus, overtime, commission, allowance } = additionalPaygIncomes || this.state.additionalPaygIncomes

      this.setState({
        additionalPaygIncomes: {
          bonus: { ...this.baseState.additionalPaygIncomes.bonus, ...bonus, active: this.calcActive(bonus), },
          overtime: { ...this.baseState.additionalPaygIncomes.overtime, ...overtime, active: this.calcActive(overtime), },
          commission: { ...this.baseState.additionalPaygIncomes.commission,...commission, active: this.calcActive(commission), },
          allowance: { ...this.baseState.additionalPaygIncomes.allowance,...allowance, active: this.calcActive(allowance), }
        }
      })
    }
  }

  calcActive(detail) {
    return detail ? detail.active === true : false
  }

  handleEmployerChange = (value) => {
    const { currentApplicant } = this.props
    this.props.incomeEmployerTypeChanged(value)
  }

  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null

    this.setState({ amount }, this.notifyChange)
    this.updateIncome({amount: amount})
  }

  handleFrequency = (frequency) => {
    this.setState({ frequency }, this.notifyChange)
    this.updateIncome({frequency: frequency})
  }

  updateIncome = (params) => {
    let { income } = this.props
    this.props.onChange({
      ...{ key: income.key || 0 },
      ...params
    })
  }

  handleDetailsToggle = (e) => {
    const detailName = e.target.id.split('-')[0]

    const detail = this.state.additionalPaygIncomes[detailName]
    const active = detail ? !detail.active : false

    this.setState({
      additionalPaygIncomes: {
        ...this.state.additionalPaygIncomes,
        [detailName]: {...detail, active}
      }
    }, this.notifyChange)
  }

  handleDetailsChange = (detailName, payload) => {
    const currentDetail = this.props.income.additionalPaygIncomes[detailName]
    const newDetail = { ...currentDetail, ...payload }

    this.setState({
      additionalPaygIncomes: {
        ...this.props.income.additionalPaygIncomes,
        [detailName]: newDetail
      }
    }, this.notifyChange)
  }

  notifyChange = () => {
    this.props.onChange(this.state)
  }

  renderEmployerType() {
    const {
      incomeEmployerType,
      secondaryIncomeEmployerType,
      currentApplicant
    } = this.props

    const employerType = currentApplicant === 'primary' ? incomeEmployerType : secondaryIncomeEmployerType

    return (
      <div>
        <p className='grey smaller mb-1'>Who is your employer?</p>

        <div className='row no-gutters mb-2'>
          <div className='col-12 col-sm-5'>
            <SelectBox
              name={ 'employerType'}
              checked={ employerType === 'asx200' }
              value={ 'asx200'}
              text={ 'ASX 200 company'}
              currentApplicant={currentApplicant}
              onChange={ this.handleEmployerChange }
            />
          </div>

          <div className='col-12 col-sm-4'>
            <SelectBox
              name={ 'employerType'}
              checked={ employerType === 'government' }
              value={ 'government' }
              text={ 'Government' }
              currentApplicant={currentApplicant}
              onChange={ this.handleEmployerChange }
            />
          </div>

          <div className='col-12 col-sm-3'>
            <SelectBox
              name={ 'employerType' }
              checked={ employerType === 'other' }
              value={ 'other' }
              text={ 'Other' }
              currentApplicant={currentApplicant}
              onChange={ this.handleEmployerChange }
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      showEmployerType,
      isNested,
      iconName,
      title,
      errors,
      income,
      mainIncome
    } = this.props

    const {
      amount,
      frequency,
      key,
      additionalPaygIncomes
    } = income

    let {
      bonus,
      overtime,
      commission,
      allowance,
      } = this.state.additionalPaygIncomes;

    if (this.props.income.additionalPaygIncomes === undefined) {
      const { additionalPaygIncomes } = this.state
      bonus = additionalPaygIncomes.bonus
      overtime = additionalPaygIncomes.overtime
      commission = additionalPaygIncomes.commission
      allowance = additionalPaygIncomes.allowance
    }

    return (
      <div className={ isNested ? 'income' : ''}>
        {isNested && <IncomeHeader iconName={ iconName } title={ title } />}
        {showEmployerType && this.renderEmployerType()}
        <div className="mb-2">
          <InputBox
            label={ 'What is your base salary?' }
            labelClass='grey'
            type={ 'salaryAmount' }
            amount={ amount }
            frequency={ frequency }
            handleAmount={ this.handleAmount }
            handleFrequency={ this.handleFrequency }
            errorMessage={ errors && errors.amount }
            inputMode='numeric'
          />
        </div>
        {!isNested &&
          <div>
            <hr />
            <div className='qn'>If applicable, please provide details for:</div>
          </div>
        }
        <div className={ isNested ? 'ml-2 pl-3 border-left border-grey' : '' }>
          <Checkbox
            id={'bonus-' + key}
            text='Bonus'
            checked={ bonus && bonus.active }
            onClick={ this.handleDetailsToggle }
          />
          {bonus && bonus.active &&
            <Bonus type="bonus"
                   errors={ errors && errors.bonus }
                   onChange={ this.handleDetailsChange }
                   { ...bonus }
            />
          }
          <hr />
          <Checkbox
            id={'overtime-' + key}
            text='Overtime'
            checked={ overtime && overtime.active }
            onClick={ this.handleDetailsToggle }
          />
          {overtime && overtime.active &&
            <Overtime type="overtime"
                      errors={ errors && errors.overtime }
                      showPeriod={ true }
                      onChange={ this.handleDetailsChange }
                      { ...overtime }
            />
          }
          <hr />
          <Checkbox
            id={'commission-' + key}
            text='Commission'
            checked={ commission && commission.active }
            onClick={ this.handleDetailsToggle }
          />
          {commission && commission.active &&
            <Commission type="commission"
                        errors={ errors && errors.commission }
                        onChange={ this.handleDetailsChange }
                        { ...commission }
            />
          }
          <hr />
          <Checkbox
            id={'allowance-' + key}
            text='Untaxed Allowance'
            checked={ allowance && allowance.active }
            onClick={ this.handleDetailsToggle }
          />
          {allowance && allowance.active &&
            <Allowance type="allowance"
                       errors={ errors && errors.allowance }
                       showPeriod={ false }
                       onChange={ this.handleDetailsChange }
                       { ...allowance }
            />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    incomeEmployerType: getLoanApplicationUser(state).incomeEmployerType,
    secondaryIncomeEmployerType: getSecondaryLoanApplicationUser(state).incomeEmployerType,
    mainIncome: getMainIncome(state),
  }
};

export default connect(mapStateToProps, {
  incomeEmployerTypeChanged,
}) (PAYG)
